import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';

interface PageMetadata {
    id: string;
    canonical: string;
    title: string;
    description: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    zinc?: string;
    zincDate?: string;
    extraTags?: { [key: string]: string }
}

const defaultMetadata: PageMetadata = {
    "id": "pc-home",
    // Default
    "canonical": "https://pchaines.com",
    "title": "PC Haines, Inc.",
    "description": "PC Haines, Inc. in Salunga, PA has been providing wall and ceiling contractor services for more than 25 years. We can work on metals, wood and plastics, and thermal and moisture. Our specialization also includes structural metal framing and trusses. Visit our website to learn more.",
    extraTags: {
        // OG
        "og:title": "PC Haines, Inc.",
        "og:url": "https://pchaines.com",
        "og:description": "PC Haines, Inc. in Salunga, PA has been providing wall and ceiling contractor services for more than 25 years. We can work on metals, wood and plastics, and thermal and moisture. Our specialization also includes structural metal framing and trusses. Visit our website to learn more.",
        "og:type": "website",
        "og:image": "assets/og-image.jpg",
        "og:image:alt": "PC Haines, Inc. logo",
        // Twitter
        "twitter:card": "summary_large_image",
        "twitter:title": "PC Haines, Inc.",
        "twitter:url": "https://pchaines.com",
        "twitter:description": "PC Haines, Inc. in Salunga, PA has been providing wall and ceiling contractor services for more than 25 years. We can work on metals, wood and plastics, and thermal and moisture. Our specialization also includes structural metal framing and trusses. Visit our website to learn more.",
        "twitter:image": "assets/og-image.jpg",
        "twitter:image:alt": "PC Haines, Inc. logo"
    }
};

const meta_lookup: { [id: string]: PageMetadata } = {
    "pc-home": {
        "id": "pc-home",
        // Default
        "canonical": "https://pchaines.com",
        "title": "PC Haines, Inc.",
        "description": "PC Haines, Inc. in Salunga, PA has been providing wall and ceiling contractor services for more than 25 years. We can work on metals, wood and plastics, and thermal and moisture. Our specialization also includes structural metal framing and trusses. Visit our website to learn more.",
        extraTags: {
            // OG
            "og:title": "PC Haines, Inc.",
            "og:url": "https://pchaines.com",
            "og:description": "PC Haines, Inc. in Salunga, PA has been providing wall and ceiling contractor services for more than 25 years. We can work on metals, wood and plastics, and thermal and moisture. Our specialization also includes structural metal framing and trusses. Visit our website to learn more.",
            "og:type": "website",
            "og:image": "assets/og-image.jpg",
            "og:image:alt": "PC Haines, Inc. logo",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines, Inc.",
            "twitter:url": "https://pchaines.com",
            "twitter:description": "PC Haines, Inc. in Salunga, PA has been providing wall and ceiling contractor services for more than 25 years. We can work on metals, wood and plastics, and thermal and moisture. Our specialization also includes structural metal framing and trusses. Visit our website to learn more.",
            "twitter:image": "assets/og-image.jpg",
            "twitter:image:alt": "PC Haines, Inc. logo"
        }
    },
    "about-us": {
        "id": "about-us",
        // Default
        "canonical": "https://pchaines.com/about-us",
        "title": "PC Haines Inc. | About Us",
        "description": "For over 20 years, PC Haines has served general contractors on projects throughout central Pennsylvania as a leading ceiling and wall contractor.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | About Us",
            "og:url": "https://pchaines.com/about-us",
            "og:description": "For over 20 years, PC Haines has served general contractors on projects throughout central Pennsylvania as a leading ceiling and wall contractor.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/banner-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | About Us",
            "twitter:url": "https://pchaines.com/about-us",
            "twitter:description": "For over 20 years, PC Haines has served general contractors on projects throughout central Pennsylvania as a leading ceiling and wall contractor.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/about/banner-d.webp",
        }
    },
    "contact-us": {
        "id": "contact-us",
        // Default
        "canonical": "https://pchaines.com/contact-us",
        "title": "PC Haines Inc. | Contact Us",
        "description": "Get in touch with PC Haines, a leading ceiling and wall contractor in central Pennsylvania.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Contact Us",
            "og:url": "https://pchaines.com/contact-us",
            "og:description": "Get in touch with PC Haines, a leading ceiling and wall contractor in central Pennsylvania.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/contact/banner-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Contact Us",
            "twitter:url": "https://pchaines.com/contact-us",
            "twitter:description": "Get in touch with PC Haines, a leading ceiling and wall contractor in central Pennsylvania.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/contact/banner-d.webp",
        }
    },
    "our-services": {
        "id": "our-services",
        // Default
        "canonical": "https://pchaines.com/services",
        "title": "PC Haines Inc. | Services",
        "description": "PC Haines provides multiple commercial wall and ceiling services, and we have the experience and crew to specialize in each one.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Services",
            "og:url": "https://pchaines.com/services",
            "og:description": "PC Haines provides multiple commercial wall and ceiling services, and we have the experience and crew to specialize in each one.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-4-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Services",
            "twitter:url": "https://pchaines.com/services",
            "twitter:description": "PC Haines provides multiple commercial wall and ceiling services, and we have the experience and crew to specialize in each one.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-4-d.webp",
        }
    },
    "division-5": {
        "id": "division-5",
        // Default
        "canonical": "https://pchaines.com/services/division-5",
        "title": "PC Haines Inc. | Division 5 - Metals",
        "description": "PC Haines takes the structural metal framing & trusses very seriously. We realize this complex task sets up the whole integrity of  the project and we guarantee 100% quality craftsmanship.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Division 5 - Metals",
            "og:url": "https://pchaines.com/services/division-5",
            "og:description": "PC Haines takes the structural metal framing & trusses very seriously. We realize this complex task sets up the whole integrity of  the project and we guarantee 100% quality craftsmanship.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-1-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Division 5 - Metals",
            "twitter:url": "https://pchaines.com/services/division-5",
            "twitter:description": "PC Haines takes the structural metal framing & trusses very seriously. We realize this complex task sets up the whole integrity of  the project and we guarantee 100% quality craftsmanship.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-1-d.webp",
        }
    },
    "division-6": {
        "id": "division-6",
        // Default
        "canonical": "https://pchaines.com/services/division-6",
        "title": "PC Haines Inc. | Division 6 - Wood & Plastics",
        "description": "Wood and plastics have a wide range of uses and applications on commercial projects. At PC Haines, we place a high priority on completing every project with top-quality materials to ensure you get a superior finished product.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Division 6 - Wood & Plastics",
            "og:url": "https://pchaines.com/services/division-6",
            "og:description": "PC Haines specializes in Division 6 - Wood & Plastics, providing top-notch craftsmanship and attention to detail in all wood and plastic-related projects.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-3-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Division 6 - Wood & Plastics",
            "twitter:url": "https://pchaines.com/services/division-6",
            "twitter:description": "Wood and plastics have a wide range of uses and applications on commercial projects. At PC Haines, we place a high priority on completing every project with top-quality materials to ensure you get a superior finished product.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-3-d.webp",
        }
    },
    "division-7": {
        "id": "division-7",
        // Default
        "canonical": "https://pchaines.com/services/division-7",
        "title": "PC Haines Inc. | Division 7 - Thermal & Moisture Protection",
        "description": "Division 7 - Thermal & Moisture Protection focuses on providing superior solutions for building envelope performance. At PC Haines, we understand the importance of protecting your investment from the elements.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Division 7 - Thermal & Moisture Protection",
            "og:url": "https://pchaines.com/services/division-7",
            "og:description": "PC Haines specializes in Division 7 - Thermal & Moisture Protection, providing top-notch craftsmanship and attention to detail in all thermal and moisture protection projects.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-5-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Division 7 - Thermal & Moisture Protection",
            "twitter:url": "https://pchaines.com/services/division-7",
            "twitter:description": "Division 7 - Thermal & Moisture Protection focuses on providing superior solutions for building envelope performance. At PC Haines, we understand the importance of protecting your investment from the elements.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-5-d.webp",
        }
    },
    "division-9": {
        "id": "division-9",
        // Default
        "canonical": "https://pchaines.com/services/division-9",
        "title": "PC Haines Inc. | Division 9 - Finishes",
        "description": "Division 9 - Finishes focuses on providing high-quality products and installation services for all types of finishes. At PC Haines, we prioritize energy efficiency and aesthetic appeal.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Division 9 - Finishes",
            "og:url": "https://pchaines.com/services/division-9",
            "og:description": "PC Haines specializes in Division 9 - Finishes, providing top-notch craftsmanship and attention to detail in all finishes projects.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-2-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Division 9 - Finishes",
            "twitter:url": "https://pchaines.com/services/division-9",
            "twitter:description": "PC Haines specializes in Division 9 - Finishes, providing top-notch craftsmanship and attention to detail in all finishes projects.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-2-d.webp",
        }
    },
    "division-10": {
        "id": "division-10",
        // Default
        "canonical": "https://pchaines.com/services/division-10",
        "title": "PC Haines Inc. | Division 10 - Specialties",
        "description": "Division 10 - Specialties focuses on providing high-quality products and installation services for all types of specialty construction. At PC Haines, we prioritize energy efficiency and aesthetic appeal.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Division 10 - Specialties",
            "og:url": "https://pchaines.com/services/division-10",
            "og:description": "PC Haines specializes in Division 10 - Specialties, providing top-notch craftsmanship and attention to detail in all specialties projects.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-6-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Division 10 - Specialties",
            "twitter:url": "https://pchaines.com/services/division-10",
            "twitter:description": "PC Haines specializes in Division 10 - Specialties, providing top-notch craftsmanship and attention to detail in all specialties projects.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/home/slider-6-d.webp",
        }
    },
    "projects": {
        "id": "projects",
        // Default
        "canonical": "https://pchaines.com/projects",
        "title": "PC Haines Inc. | Projects",
        "description": "PC Haines has a diverse portfolio of projects showcasing our expertise in various construction disciplines. Explore our projects to see our commitment to quality and innovation.",
        extraTags: {
            // OG
            "og:title": "PC Haines Inc. | Projects",
            "og:url": "https://pchaines.com/projects",
            "og:description": "PC Haines has a diverse portfolio of projects showcasing our expertise in various construction disciplines. Explore our projects to see our commitment to quality and innovation.",
            "og:type": "website",
            "og:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/projects/banner-d.webp",
            // Twitter
            "twitter:card": "summary_large_image",
            "twitter:title": "PC Haines Inc. | Projects",
            "twitter:url": "https://pchaines.com/projects",
            "twitter:description": "PC Haines has a diverse portfolio of projects showcasing our expertise in various construction disciplines. Explore our projects to see our commitment to quality and innovation.",
            "twitter:image": "https://tsgblob.blob.core.windows.net/pc-haines/assets/images/projects/banner-d.webp",
        }
    },
};

@Injectable({
    providedIn: 'root'
})
export class MetaService {

    constructor(
        private meta: Meta,
        private title: Title,
        @Inject(DOCUMENT)private document: Document
    ) { }


    setMetadata(id: string) {
        let m = meta_lookup[id];
        m = m || defaultMetadata;

        if (!environment.production) {
            this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
        }
        
        this.meta.updateTag({ name: 'description', content: m.description });
        this.meta.updateTag({ name: 'og:title', content: m.ogTitle || m.title });
        this.meta.updateTag({ name: 'og:description', content: m.ogDescription || m.description });

        // override canonical link
        let canonicalLink = this.document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
            canonicalLink.setAttribute('href', m.canonical);
        }

        if (m.ogImage) {
            this.meta.updateTag({ name: 'og:image', content: m.ogImage });
        }

        if (m.extraTags) {
            for (let key of Object.keys(m.extraTags)) {
                this.meta.updateTag({ name: key, content: m.extraTags[key] });
            }
        }

        this.title.setTitle(m.title);
    }


    setProjectMetadata(metaObject: any) {
        console.log('Setting metadata from page object:', metaObject);

        let m = metaObject;
        m = m || defaultMetadata;

        if (!environment.production) {
            this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
        }
        
        this.meta.updateTag({ name: 'description', content: m.metaDescription });

        this.meta.updateTag({ name: 'og:url', content: 'https://pchaines.com/projects/' + m.id });
        this.meta.updateTag({ name: 'og:title', content: m.ogTitle || m.title });
        this.meta.updateTag({ name: 'og:description', content: m.ogDescription || m.description });
        this.meta.updateTag({ name: 'og:image', content: m.bannerImgUrl });
        this.meta.updateTag({ name: 'og:type', content: 'website' });
        
        this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
        this.meta.updateTag({ name: 'twitter:title', content: m.ogTitle || m.title });
        this.meta.updateTag({ name: 'twitter:url', content: 'https://pchaines.com/projects/' + m.id });
        this.meta.updateTag({ name: 'twitter:description', content: m.ogDescription || m.description });
        this.meta.updateTag({ name: 'twitter:image', content: m.bannerImgUrl });

        // override canonical link
        let canonicalLink = this.document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
            canonicalLink.setAttribute('href', m.canonical);
        }

        this.title.setTitle(m.title);
    }
}
